import { render, staticRenderFns } from "./JtopoNetPlane.vue?vue&type=template&id=1996bbcc&scoped=true&"
import script from "./JtopoNetPlane.vue?vue&type=script&lang=js&"
export * from "./JtopoNetPlane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1996bbcc",
  null
  
)

export default component.exports